module.exports = __webpack_public_path__ + "img/qufu-name-1.f019a7bf.png";